import { render, staticRenderFns } from "./countries.vue?vue&type=template&id=8c8de290"
import script from "./countries.vue?vue&type=script&lang=js"
export * from "./countries.vue?vue&type=script&lang=js"
import style0 from "./countries.vue?vue&type=style&index=0&id=8c8de290&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports